const publicBase = () => (process.env.PUBLIC_URL || "").replace(/\/$/, "");

const defaultFaviconHref = () => `${publicBase()}/favicon.ico`;
const defaultAppleHref = () => `${publicBase()}/logo192.png`;

function iconTypeFromUrl(url) {
  const path = String(url).split("?")[0].toLowerCase();
  if (path.endsWith(".png")) return "image/png";
  if (path.endsWith(".jpg") || path.endsWith(".jpeg")) return "image/jpeg";
  if (path.endsWith(".webp")) return "image/webp";
  if (path.endsWith(".ico")) return "image/x-icon";
  if (path.endsWith(".svg")) return "image/svg+xml";
  return undefined;
}

/**
 * When single-vendor storefront has a store logo URL, use it for tab + mobile home-screen icon.
 * Otherwise restore CRA `public` defaults (replace those files with your brand for no-JS / crawlers).
 */
export function applyStorefrontFavicon(storeLogoUrl) {
  const logo =
    typeof storeLogoUrl === "string" && storeLogoUrl.trim()
      ? storeLogoUrl.trim()
      : null;

  const icon = document.querySelector('link[rel="icon"]');
  const apple = document.querySelector('link[rel="apple-touch-icon"]');

  if (logo) {
    if (icon) {
      icon.href = logo;
      const t = iconTypeFromUrl(logo);
      if (t) icon.setAttribute("type", t);
      else icon.removeAttribute("type");
    }
    if (apple) {
      apple.href = logo;
    }
    return;
  }

  const fav = defaultFaviconHref();
  const ap = defaultAppleHref();
  if (icon) {
    icon.href = fav;
    icon.setAttribute("type", "image/x-icon");
  }
  if (apple) {
    apple.href = ap;
  }
}
